function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M343.4,24.3v-0.7c-0.1,0-0.2,0-0.3,0c-1.3,0-2.6,0.1-3.9,0.3c-2,0.1-4,0.7-6,1.7c-14.7,6.1-26.3,25.3-40.3,48.7 c-20.5,34.2-46.1,76.8-89.9,87.5c-17.3,4.2-37.7,28.7-57.2,53.4c-1.8,2.2-3.4,4.3-4.9,6.2l-0.5,0.6L0,280l113.9,80.1 c47.8-22.5,62.4,20.5,102,128.3c79.7-8.9,133.1-136.2,177.5-144.6c55.1-10.4,59.7,31.8,118.5,68.1 C452.9,283.9,390.1,36.3,343.4,24.3z M171.8,316.5l-56.9,28.8l-88.6-62.4l119.4-49.4l23.1,17.2l35.5,26.9 C194.5,291.4,183.7,304.5,171.8,316.5z M212,266.8l-35.3-26.3L155,224.2c0.3-0.4,0.6-0.7,0.8-1.1c12.5-15.9,35.7-45.4,50.2-48.9 c40.3-9.8,65.7-42.1,85.6-73.3C272.5,149.1,248.7,212.3,212,266.8z"
});

function SvgMatlab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatlab);
export default __webpack_public_path__ + "static/media/matlab.cd2855a8.svg";
export { ForwardRef as ReactComponent };